import React from 'react';
import { Tooltip, Whisper } from 'rsuite';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import HealthLevels from '../../constants/common/HealthLevels';
import HealthLevelLabels from '../../constants/common/HealthLevelLabels';

const StyledTrafficlight = styled.div`
  transform: rotate(90deg);
  display: inline-block;
  vertical-align: top;
  position: relative;
  top: -15px;
  left: 15px;
`;

const TrafficlightSwitchPropByValue = {
  [HealthLevels.GO]: { GreenOn: true },
  [HealthLevels.SLOW]: { YellowOn: true },
  [HealthLevels.WHOA]: { RedOn: true }
};

const StoplightTooltip = ({ value, ...props }) => (
  <Tooltip {...props}>
    Traffic-Light Nutrition Indicator: {HealthLevelLabels[value]}
  </Tooltip>
);

StoplightTooltip.propTypes = {
  value: PropTypes.number.isRequired
};

const FoodStoplight = ({ value, ...props }) => (
  <Whisper
    placement="top"
    trigger="hover"
    speaker={<StoplightTooltip value={value} />}
  >
    <StyledTrafficlight {...props} {...TrafficlightSwitchPropByValue[value]} />
  </Whisper>
);

FoodStoplight.propTypes = {
  value: PropTypes.number.isRequired
};

export default FoodStoplight;
